import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Spin } from "antd";
import { toast } from "react-toastify";
import ContentLayout from "../../../layout/ContentLayout";
import { Container } from "../../../components/content";
import styles from "../../../styles/mobileInfoPage.module.scss";
import quizService from "../../../api/quiz-api";
import QuizFormFields from "../../../components/quiz/QuizFormFields";
import { validatedQuizForm } from "../../../utils/quiz.util";

export default function IzmeniKviz() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        fetchQuiz();
    }, [id]);

    const fetchQuiz = async () => {
        setLoading(true);
        try {
            const response = await quizService.getById(id);
            if (!response.success) {
                toast.error(response.message || 'Greška pri učitavanju kviza');
                navigate('/kvizovi');
                return;
            }
            setFormData(response.data);
        } finally {
            setLoading(false);
        }
    };

    const updateFormData = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        if (!validatedQuizForm(formData)) return;

        setSaving(true);
        try {
            const response = await quizService.update(formData._id, formData);
            if (!response.success) {
                toast.error(response.message || 'Greška prilikom čuvanja kviza');
                return;
            }
            toast.success('Kviz je uspešno ažuriran!');
            navigate('/kvizovi');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <Spin size="large" />
            </div>
        );
    }

    if (!formData) {
        return null;
    }

    return (
        <Container>
            <Link to="/kvizovi" className="link_btn" style={{ marginBottom: '12px' }}>
                <img alt="back" src="/assets/icons/chevron.svg" />
                <span>Nazad</span>
            </Link>

            <ContentLayout pt={true}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
                    <h2 className={styles.pageTitle} style={{ margin: 0 }}>Izmena kviza</h2>
                    <Button className="btn-primary" onClick={handleSave} loading={saving}>
                        Sačuvaj izmene
                    </Button>
                </div>

                <QuizFormFields formData={formData} updateFormData={updateFormData} />
            </ContentLayout>
        </Container>
    );
}
